import { LINKS } from '@/Module/Core/Constant';
import type { IPage } from '@/Module/Core/Model/DataModel';
import { Wrapper } from '@/Module/Store/Component';
import { TeacherDetail } from '@/Module/Teacher/Component';
import { REDIRECT_TOKENS } from '@/Module/Teacher/Constant';
import { getLessonByTeacherIdAction, getTeacherBySeoUrlSlugAction } from '@/Module/Teacher/Store/Action';
import { teacherSetSelectedIdAction } from '@/Module/Teacher/Store/Slice/TeacherSlice';
const TeacherPage: IPage = () => {
  return <TeacherDetail data-sentry-element="TeacherDetail" data-sentry-component="TeacherPage" data-sentry-source-file="index.tsx" />;
};
export const getServerSideProps = Wrapper.getServerSideProps(store => async ({
  query,
  res
}) => {
  const slug = String(query?.slug);
  if (REDIRECT_TOKENS.find(token => slug === token)) {
    res.writeHead(301, {
      location: LINKS.TEACHER_LIST
    });
    res.end();
  }
  if (slug) {
    const data = await store.dispatch(getTeacherBySeoUrlSlugAction(slug)).unwrap().then(({
      id
    }) => {
      return Promise.allSettled([store.dispatch(teacherSetSelectedIdAction(id)), store.dispatch(getLessonByTeacherIdAction(id))]);
    }).catch(() => {
      return 'SlugNotFound';
    });
    if (data === 'SlugNotFound') {
      return {
        notFound: true
      };
    }
    return {
      props: {}
    };
  }
  return {
    notFound: true
  };
});
export default TeacherPage;